/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { showDrivabeCloseModal } from '../../../actions/modalActions';
import { showModalDrivabeSuccessSubmitted } from '../../../actions/modalCallbackActions';
import { CLAIM_END_PAGE, FNOL_CLAIM_PROGRESS_MOBILE } from '../../../routes/routes';
import { navigateTo } from '../../../actions/navigationActions';
import { setFollowUpSteps, submitDrivableClaim } from '../../../actions/claimSubmitActions';
import { SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE, SET_STEPS_FOLLOW_UP_PEDESTRIAN, SET_STEPS_FOLLOW_UP_POTHOLE, SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE_STATIONARY, COMPREHENSIVE_MOTORBIKE_COVER_TYPE, COMPREHENSIVE_CAR_COVER_TYPE, AGREED_VALUE_COVER_TYPE } from '../../../constants/constants';
import { isMobile } from 'react-device-detect';

class FnolStep10Sub2 extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async handleSubmit() {
        var followUpSteps = followUpMapping.find(x => x.id == this.props.claimSubmit.incidentEventType.id)?.journey;

        if (followUpSteps && this.props.ssp.followUpEnabled) {
            if (followUpSteps === SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE && this.props.claimSubmit.isStationary === "yes") {
                followUpSteps = SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE_STATIONARY;
            }
            await this.props.dispatchAction(setFollowUpSteps(followUpSteps))
            if (isMobile)
                await this.props.handleRedirect(FNOL_CLAIM_PROGRESS_MOBILE);
        }
        else {
            await this.props.handleRedirect(CLAIM_END_PAGE);
            this.props.dispatchAction(showModalDrivabeSuccessSubmitted());
        }
    }

    async handleCancel() {
        this.props.dispatchShowDrivabeCloseClaim();
    }

    public render() {
        return (
            <div className="col ssp-container-fnol-drivable ssp-container-fnol-step-header-padding">
                <div className="row noma">
                    <div className="col-12 nopa ssp-header-fnol-drivable">
                        <div className="row noma">
                            <div className="fnol-step-header-icon-area">
                                <img src={'/my-policy/Images/Claims/Numbers/number-' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red-32x32px.svg'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                            </div>
                            <div className="col fnol-step-header-title-area">
                                <h3>Claim submitted. Finalise details</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row noma">
                    <div className="col-12 fnol-steps-info-section-holder">
                        <hr className="hr-minus21px" />
                        <div className="mb-10px">
                            <p className="font-size-16px font-weight-bold mb-3px">Excess</p>
                            <br />
                            <p>Based on the info you've provided, the estimated excess you'll need to pay is:</p>
                            <p id="excess-amount" className="excessAmount">{this.props.profile.currencySymbol + " " + this.props.profile.selectedPersonalClaim?.totalExcess}</p>
                        </div>

                        <div className="col-12 nopa fnol-steps-buttonholder mt-10px">
                            <button id="continueClaim" className="btn btn-solid-red fnol-buttonreverse-button-next" onClick={this.handleSubmit}>Continue with claim</button>
                            <button className="btn btn-outline-red fnol-buttonreverse-button-back" onClick={this.handleCancel}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const followUpMapping = [
    { id: 13, journey: SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE },
    { id: 558, journey: SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE },
    { id: 676, journey: SET_STEPS_FOLLOW_UP_PEDESTRIAN },
    { id: 11, journey: SET_STEPS_FOLLOW_UP_POTHOLE },
];

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit,
        ssp: state.ssp,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSubmitDrivableClaim: (isRecordPurpose, isThirdPartyclaim) => dispatch(submitDrivableClaim(isRecordPurpose, isThirdPartyclaim)),
        handleRedirect: (destination) => dispatch(navigateTo(destination)),
        dispatchShowDrivabeCloseClaim: () => dispatch(showDrivabeCloseModal()),
        dispatchAction: (e) => dispatch(e),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FnolStep10Sub2)